import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useRef } from "react";
import JsBarcode from "jsbarcode";
import styles from "./Barcode.module.scss";
export const Barcode = ({ value, displayValue = false, margin = 10, width = 2, height = 100, background = "transparent", fontSize = 20, textMargin = 10, }) => {
    const svgRef = useRef(null);
    const barcodeOptions = useMemo(() => ({
        format: "CODE128",
        displayValue,
        margin,
        width,
        height,
        background,
        fontSize,
        textMargin,
    }), [displayValue, margin, width, height, background, fontSize, textMargin]);
    useEffect(() => {
        if (svgRef.current) {
            try {
                JsBarcode(svgRef.current, value, barcodeOptions);
            }
            catch (error) {
                console.error(error);
            }
        }
    }, [value, barcodeOptions]);
    return _jsx("svg", { "data-testid": "barcodeSvg", ref: svgRef, className: styles.barcodeSvg });
};
//# sourceMappingURL=Barcode.js.map